import { PCScreen } from 'components/guide/PCScreen';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    children: React.ReactNode;
}

export const Page = (props: Props) => {
    return (
        <S_Page className={props.className}>
            <PCScreen>
                <S_Inner>{props.children}</S_Inner>
            </PCScreen>
        </S_Page>
    );
};

const S_Page = styled.div`
    margin: 120px auto 0px auto;
`;

const S_Inner = styled.div`
    width: 100%;
`;
